export default "__VITE_PUBLIC_ASSET__b01973a8__"